import * as React from 'react';
import { IImageEditorFirm } from '../Entities';
import ImageEditorFirmsListRow from './ImageEditorFirmsListRow';
import { Translate } from '../../../shared/LanguageService';

interface IImageEditorFirmsListProps {
    imageEditorFirms: IImageEditorFirm[];
    showDiscontinued: boolean;
    onClickEdit: (id: number) => void;
    discontinued: (id: number, isDiscontinued: number) => void;
}

const ImageEditorFirmsList = (props: IImageEditorFirmsListProps) => {
    return (
        <table className="table table-hover table-responsive">
            <thead>
                <tr>
                    <th>{Translate('image-editor-firms/list/header/name')}</th>
                    {props.showDiscontinued ? (
                        <th>{Translate('image-editor-firms/list/header/is-discontinued')}</th>
                    ) : null}
                </tr>
            </thead>
            <tbody>
                {props.imageEditorFirms
                    .sort((a: IImageEditorFirm, b: IImageEditorFirm) => {
                        if (a.name < b.name) {
                            return -1;
                        }
                        if (a.name > b.name) {
                            return 1;
                        }

                        return 0;
                    })
                    .map((imageEditorFirm: IImageEditorFirm, index: number) => (
                        <ImageEditorFirmsListRow
                            imageEditorFirm={imageEditorFirm}
                            onClickEdit={props.onClickEdit}
                            discontinued={props.discontinued}
                            key={index}
                        />
                    ))}
            </tbody>
        </table>
    );
};

export default ImageEditorFirmsList;
